
const colors = ['var(--border-color-light)','rgba(26,187,156,0.25)','rgba(26,187,156,0.5)','rgba(26,187,156,0.75)','var(--primary)'];
const heatmap = document.getElementById('heatmap');
let html = '';
for (let i = 0; i < 140; i++) {
  const lvl = Math.floor(Math.random() * 5);
  html += `<span style="aspect-ratio:1;background:${colors[lvl]};border-radius:2px"></span>`;
}
heatmap.innerHTML = html;
